
import React, { createContext, useContext, useEffect, useState } from "react";

const GalleryContext = createContext();

export const useGallery = () => useContext(GalleryContext);

export const GalleryProvider = ({ children }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("images")) || [];
    setImages(data);
  }, []);

  const addImage = (img) => {
    const newImage = {
      ...img,
      id: Date.now(),
    };

    const updated = [...images, newImage];
    setImages(updated);
    localStorage.setItem("images", JSON.stringify(updated));
  };

  const updateImage = (updatedImage) => {
    const updated = images.map((img) =>
      img.id === updatedImage.id ? updatedImage : img
    );

    setImages(updated);
    localStorage.setItem("images", JSON.stringify(updated));
  };

  const deleteImage = (id) => {
    const updated = images.filter((img) => img.id !== id);
    setImages(updated);
    localStorage.setItem("images", JSON.stringify(updated));
  };

  return (
    <GalleryContext.Provider
      value={{ images, addImage, updateImage, deleteImage }}
    >
      {children}
    </GalleryContext.Provider>
  );
};